module.exports = __webpack_public_path__ + "static/media/chevron-right.c5705d80.svg";